/**
 * Root-level business-plane alias routes mounted by MainRouter (N1 route-plane
 * corrections). Extracted from `router/index.tsx` so tests can exercise real
 * react-router-dom path matching + `Navigate` resolution without mounting
 * MainRouter's large lazy domain-router graph (which pulls in
 * `import.meta.env`-dependent modules that are awkward to render under Jest).
 *
 * Exported as a plain array of `<Route>` elements — spread directly as
 * children of a `<Routes>` — rather than wrapped in a component, because
 * react-router-dom's `<Routes>` only resolves direct `Route`/`Fragment`
 * children (a custom wrapper component would not be recognized).
 */
import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { RoleAwareLandingRedirect } from './RoleAwareLandingRedirect';

export const BUSINESS_PLANE_ROOT_ALIAS_ROUTES: React.ReactElement[] = [
  <Route key="root-alias" path="/" element={<RoleAwareLandingRedirect />} />,
  <Route key="today-alias" path="/today" element={<Navigate to="/workspace" replace />} />,
  <Route key="today-splat-alias" path="/today/*" element={<Navigate to="/workspace" replace />} />,
  /**
   * `/marketing` is a legacy menu key consolidated into `/appeal` (see
   * business-menu-rbac.ts MENU_KEY_TO_DOMAIN_CATEGORY 'M3 marketing → appeal
   * consolidation'). It is classified as a business-plane path
   * (pathPlanes.BUSINESS_PLANE_PREFIXES) but previously had no matching
   * Route in MainRouter, so it silently fell through to the generic `*`
   * BusinessNotFoundPage — an ambiguous, unclassified 404 caused by plane
   * drift rather than an intentional "not found". Redirect the alias
   * explicitly instead.
   */
  <Route
    key="marketing-alias"
    path="/marketing"
    element={<Navigate to="/appeal/dashboard" replace />}
  />,
  <Route
    key="marketing-splat-alias"
    path="/marketing/*"
    element={<Navigate to="/appeal/dashboard" replace />}
  />,
];
